import { Suspense, lazy, useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Loader from './components/Loader/Loader';
import FloatingButtons from './components/FloatingButtons/FloatingButtons';
import ScrollProgress from './components/ScrollProgress/ScrollProgress';
import CustomCursor from './components/CustomCursor/CustomCursor';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import PropertyPage from './pages/PropertyPage/PropertyPage';
import SpaStickyButton from './components/SpaStickyButton/SpaStickyButton';
import './App.css';

const Home = lazy(() => import('./pages/Home/Home'));
const About = lazy(() => import('./pages/About/About'));
const Rooms = lazy(() => import('./pages/Rooms/Rooms'));
const RoomDetails = lazy(() => import('./pages/RoomDetails/RoomDetails'));
const GalleryPage = lazy(() => import('./pages/GalleryPage/GalleryPage'));
const Services = lazy(() => import('./pages/Services/Services'));
const Contact = lazy(() => import('./pages/Contact/Contact'));
const Spa = lazy(() => import('./components/Spa/Spa'));

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Helmet>
        <title>Salkara Inn | Luxury Boutique Hotel in Palakkad</title>
        <meta
          name="description"
          content="Salkara Inn is a five-star luxury boutique hotel in Palakkad, Kerala, offering Deluxe Rooms and Suites with modern comfort and business-friendly amenities."
        />
      </Helmet>

      <Loader visible={loading} />
      <ScrollProgress />
      {/* <CustomCursor /> */}
      <ScrollToTop />
      <Navbar />
      <SpaStickyButton />

      <main>
        <Suspense fallback={<div className="route-fallback" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/rooms" element={<Rooms />} />
            <Route path="/rooms/:roomId" element={<RoomDetails />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/properties/:id" element={<PropertyPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/spa" element={<Spa />} />
          </Routes>
        </Suspense>
      </main>

      <FloatingButtons />
      <Footer />
    </>
  );
}